import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import type { RejectOrderPaymentRequest, SellerOrderDetail } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminOrders } from "@/lib/query/core/invalidation";

type RejectStoreOrderPaymentInput = {
  storeId: string;
  orderId: string;
} & RejectOrderPaymentRequest;

export function useRejectStoreOrderPaymentMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeId, orderId, ...body }: RejectStoreOrderPaymentInput) =>
      apiJsonClient<SellerOrderDetail>(
        endpoints.admin.storeOrderReviewReject(storeId, orderId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: async (_data, variables) => {
      await invalidateAdminOrders(queryClient, variables.storeId);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
  };
}
